import { AssistantChat } from "@/components/assistant/AssistantChat";
import { AGENT_LAYER_SLOGAN, ROUTES } from "@/lib/routes";
import { Link } from "react-router-dom";

/** Intelligence — read-only Protocol Assistant (not a keeper). */
export default function IntelligencePage() {
	return (
		<div className="container mx-auto flex flex-col px-4 py-6 pb-16">
			<div className="mb-4">
				<p className="font-mono text-[10px] font-bold uppercase tracking-wider text-yellow-400/80">
					{AGENT_LAYER_SLOGAN}
				</p>
				<h1 className="mt-1 font-mono text-xl font-bold text-yellow-400 sm:text-2xl">
					Intelligence
				</h1>
				<p className="mt-2 max-w-2xl font-mono text-sm text-yellow-400/70">
					<strong className="text-yellow-300">Informational only</strong> —
					explains protocol mechanics from docs + public on-chain data. Not a
					keeper: cannot mint, liquidate, vote, or hold API keys.
				</p>
				<p className="mt-2 font-mono text-[11px] text-yellow-400/50">
					For bots use{" "}
					<Link to={ROUTES.agents} className="underline hover:text-yellow-300">
						My Agents
					</Link>
					{" · "}
					<Link to={ROUTES.skills} className="underline hover:text-yellow-300">
						Skills
					</Link>
					{" · "}
					<a href="/llms.txt" className="underline hover:text-yellow-300">
						/llms.txt
					</a>
					{" · "}
					<a href="/docs" className="underline hover:text-yellow-300">
						/docs
					</a>
				</p>
			</div>
			<div className="flex min-h-[min(70vh,560px)] flex-col overflow-hidden rounded-xl border border-yellow-500/30 bg-black/80">
				<AssistantChat className="min-h-0 flex-1" variant="agent" />
			</div>
		</div>
	);
}
